import { useState } from "react";
import {
  Button,
  TextField,
  Modal,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
// import { Link } from "react-router-dom";
// import axios from "../api/axios";
import axios from "../../api/axios";
// import PackageTrackingStepper from "./PackingTrackingStepper";
import PackageTrackingStepper from "../../utilcomponents/PackingTrackingStepper";
// import truckship from "../../assets/truckship.jpg";

const TrackParcel = () => {
  const [trackingNumber, setTrackingNumber] = useState("");
  const [error, setError] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [trackingResult, setTrackingResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");

  const handleInputChange = (e) => {
    setTrackingNumber(e.target.value);
    setError("");
    setApiError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!trackingNumber) {
      setError("Tracking code must be provided.");
      return;
    }
    if (trackingNumber.length !== 15) {
      setError("Invalid tracking code. Must be exactly 15 characters.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("track-package", {
        trackingCode: trackingNumber,
      });

      if (response.status === 200 && response.data?.foundTrackedPackage) {
        setTrackingResult(response?.data?.foundTrackedPackage);
        setOpenModal(true);
      } else {
        setApiError("Tracking information not found.");
      }
    } catch (error) {
      console.error(error);
      setApiError("An error occurred while fetching tracking data.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenModal(false);
    setTrackingNumber("");
    setTrackingResult(null);
    setError("");
    setApiError("");
  };

  console.log({ trackingResult });

  return (
    <div className="  bg-gradient-to-b  from-[#034052]  from-5%  to-90%    to-transparent   min-h-screen  md:px-[5rem]  min-w-full  mx-auto flex  md:flex-row  flex-col   justify-center items-center   bg-center bg-no-repeat  bg-cover">
      {/* <div className="min-w-[90%]  md:min-w-[50%]"></div> */}
      <div>
        {/* <img src={truckship} alt="shipment" className="w-full h-full" /> */}
        <form
          onSubmit={handleSubmit}
          className="p-8  rounded-lg space-y-4 mx-auto   bg-white       bg-opacity-75    border-2  border-gray-200        flex flex-col justify-center items-center"
        >
          <Typography
            sx={{
              width: "100%",
              color: "#034052",
              fontWeight: { sm: 900, lg: 1800 },
              fontSize: { sm: "1.5rem", lg: "3rem" },
              letterSpacing: { lg: "-0.2rem" },
              ml: { lg: "0" },
              textAlign: { sm: "center", lg: "left" },
            }}
          >
            Track Your Package
          </Typography>
          <TextField
            label="Tracking Number"
            value={trackingNumber}
            onChange={handleInputChange}
            fullWidth
            margin="normal"
            error={!!error}
            helperText={error || apiError}
            disabled={loading}
            sx={{
              ml: { md: "5rem", lg: "0" },
              width: { xs: "100%", sm: "35rem", md: "30rem", lg: "35rem" },
              "& .MuiOutlinedInput-root": {
                borderRadius: "3rem",
                overflow: "hidden",
              },
              "& .MuiInputBase-input": {
                color: "black",
                paddingY: "0.8rem",
              },
            }}
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{
              width: { sm: "12rem", lg: "15rem" },
              mx: { sm: "auto", lg: "0" },
              color: "#034052",
              bgcolor: "#f1c24e",
              fontSize: { sm: "1.2rem", md: "1.5rem" },
              borderRadius: "1rem",
              fontWeight: 900,
              textTransform: "capitalize",
              position: "relative",
            }}
          >
            {loading ? <CircularProgress size={24} /> : "Track Now"}
          </Button>
          {/* <div className="flex flex-col mx-auto lg:flex-row justify-center lg:gap-4 items-center font-black tracking-wide  ">
					<Link className="w-[10rem] py-[0.2rem] border-2 inline-block lg:py-[0.5rem] lg:rounded-full border-gray-400 px-8 custom-yellow-text custom-blue-bg rounded-md">
						Ship Now
					</Link>
					<Link className="w-[11rem] md:w-[11rem] my-[1rem] block border-2 lg:py-[0.5rem] lg:rounded-full border-gray-400 py-[0.2rem] px-8 custom-yellow-text custom-blue-bg rounded-md">
						Get a Quote
					</Link>
				</div> */}
        </form>
        {/* <img src={truckship} alt="truck" className="w-full h-full" />
				<p className=" min-w-[60%]   text-gray-500">
					We're not just tracking, we're predicting. Get real-time updates,
					proactive alerts, and peace of mind every step of the way.
				</p> */}
      </div>

      {/* Modal for displaying tracking result */}
      <Modal
        open={openModal}
        onClose={handleClose}
        className="flex items-center justify-center min-w-full min-h-full"
      >
        <div className="bg-white rounded-lg p-6 shadow-lg w-[90%] max-w-[600px] relative">
          <Button
            onClick={handleClose}
            sx={{ position: "absolute", top: 8, right: 8 }}
            size="small"
          >
            <CloseIcon />
          </Button>
          {trackingResult ? (
            <article className="overflow-y-auto flex flex-col    text-[0.9rem]   justify-start items-start max-h-[80vh]">
              {/* Delivery Details */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white    font-medium p-2">
                  Delivery Details
                </h5>
                <ul className="list-inside my-2 text-gray-700   ">
                  <li>
                    Sender's Name: {trackingResult?.senderFullName || "N/A"}
                  </li>
                  <li>
                    Sender's Email: {trackingResult?.senderEmail || "N/A"}
                  </li>
                  <li>
                    Recipient Name: {trackingResult?.recipientFullName || "N/A"}
                  </li>
                  <li>
                    Recipient Email: {trackingResult?.recipientEmail || "N/A"}
                  </li>
                  <li>
                    Recipient Country: {trackingResult?.toCountry || "N/A"}
                  </li>
                  <li>Recipient City: {trackingResult?.toCity || "N/A"}</li>
                </ul>
              </div>

              {/* Package Details */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white font-medium p-2">
                  Package Details
                </h5>
                <ul className="list-inside my-2 text-gray-700">
                  <li>
                    Tracking Number: {trackingResult?.trackingNumber || "N/A"}
                  </li>
                  <li>Shipping Date: {trackingResult?.createdAt || "N/A"}</li>
                  <li>
                    Actual Delivery Date:{" "}
                    {trackingResult?.estimatedDeliveryDate || "N/A"}
                  </li>
                  <li>
                    Estimated Delivery Date:{" "}
                    {trackingResult?.estimatedDeliveryDate || "N/A"}
                  </li>
                </ul>
              </div>

              {/* Shipment Status */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white font-medium p-2">
                  Shipment Status
                </h5>
                <ul className="list-inside my-2 text-gray-700">
                  <li>
                    Current Status: {trackingResult?.shipmentStatus || "N/A"}
                  </li>
                  <li>Date: {trackingResult?.updatedAt || "N/A"}</li>
                </ul>
              </div>

              {/* Package Tracking History */}
              <div className="w-full mb-4">
                <h5 className="bg-blue-500 text-white font-medium p-2">
                  Package Tracking History
                </h5>
                <div className="overflow-y-auto max-h-[200px]">
                  <PackageTrackingStepper
                    steps={trackingResult.trackingHistory || []}
                  />
                </div>
              </div>
            </article>
          ) : (
            <Typography align="center" sx={{ p: 2 }}>
              No tracking data available.
            </Typography>
          )}
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default TrackParcel;
